import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Megaphone } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { whenLabel } from "@/lib/jobs";
import { TypeBadge } from "@/components/jobs/Badges";

const Card = ({ r, reload }) => {
  const [busy, setBusy] = useState(false);
  const take = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/rota/cover-requests/${r.id}/claim`); toast.success(`You're on the rota: ${data.slot.area_name} ${data.slot.template_name} ${data.slot.start}-${data.slot.end}`); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false); reload();
  };
  return (
    <div className="space-y-3 rounded-3xl border-2 border-amber-500 bg-amber-500/10 p-5" data-testid={`cover-request-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2"><span className="inline-flex items-center gap-1 text-xs font-black uppercase tracking-[0.25em] text-amber-500"><Megaphone className="h-4 w-4" /> Can you cover?</span><TypeBadge t={r.job_type} /></div>
      <p className="text-2xl font-black">{whenLabel(r.scheduled_for)}</p>
      <p className="text-lg font-bold">{r.pickup} <ArrowRight className="inline h-5 w-5" /> {r.dropoff}</p>
      <p className="text-sm text-muted-foreground" data-testid={`cover-shift-${r.id}`}>{r.shift ? `You'd take: ${r.shift.area_name} · ${r.shift.template_name} ${r.shift.start}-${r.shift.end} (${r.shift.position_label})` : "No shift at that time matches your areas or roles - call control if you can help."}</p>
      {r.shift && <button onClick={take} disabled={busy} data-testid={`cover-claim-${r.id}`} className="min-h-16 w-full rounded-2xl bg-amber-500 text-xl font-black text-black active:scale-95 disabled:opacity-50">{busy ? "Taking..." : "I'LL TAKE THIS SHIFT"}</button>}
    </div>
  );
};

export const CoverRequests = () => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/rota/cover-requests").then((r) => setRows(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  if (!rows.length) return null;
  return <div className="space-y-3" data-testid="cover-requests">{rows.map((r) => <Card key={r.id} r={r} reload={load} />)}</div>;
};
